import { useState } from 'react'
import { ChevronDown, ChevronRight } from 'lucide-react'
import type { SchemaField } from '../../../../types/schede'

interface SectionFieldProps {
  field: SchemaField
  value?: any
  onChange?: (value: any) => void
  readOnly?: boolean
  error?: string
  children?: React.ReactNode
}

export default function SectionField({ field, children }: SectionFieldProps) {
  const [isOpen, setIsOpen] = useState(field.section_default_open !== false)

  return (
    <div className="mt-3 mb-2">
      <div
        className="flex items-center gap-2 pb-1.5"
        style={{ borderBottom: '1px solid var(--color-border)' }}
      >
        {field.section_collapsible && (
          <button
            type="button"
            onClick={() => setIsOpen(!isOpen)}
            className="p-0.5 rounded hover:bg-black/5"
            style={{ color: 'var(--color-text-secondary)' }}
          >
            {isOpen ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
          </button>
        )}
        <h3
          className="text-sm font-semibold"
          style={{ color: 'var(--color-text-primary)' }}
        >
          {field.label}
        </h3>
      </div>
      {field.section_collapsible && !isOpen ? (
        <div className="text-xs mt-1" style={{ color: 'var(--color-text-tertiary)' }}>
          Sezione compressa. Clicca per espandere.
        </div>
      ) : (
        children && (
          <div className="mt-2">
            {children}
          </div>
        )
      )}
    </div>
  )
}
